// extracted by mini-css-extract-plugin
export default {"light":"style_light__oLVNI","dark":"style_dark__7ZRrY"};